import { combineReducers } from 'redux'
//import localforage from 'localforage'
import { fetchData, postData } from '../../api'
import { isClient } from '../../utils'


const FETCH_FAVOURITES_REQUEST = 'FAVOURITES/FETCH_FAVOURITES_REQUEST'
const FETCH_FAVOURITES_SUCCESS = 'FAVOURITES/FETCH_FAVOURITES_SUCCESS'
const FETCH_FAVOURITES_FAILURE = 'FAVOURITES/FETCH_FAVOURITES_FAILURE'

const UPDATE_FAVOURITES_REQUEST = 'UPDATE_FAVOURITES_REQUEST'
const UPDATE_FAVOURITES_SUCCESS = 'UPDATE_FAVOURITES_SUCCESS'
const UPDATE_FAVOURITES_FAILURE = 'UPDATE_FAVOURITES_FAILURE'

let defaultFavourites = {
    images: [],
    imageReferences: [],
    documents: []
}

const favourites = (state = {...defaultFavourites}, action) => {

    switch (action.type) {

        case FETCH_FAVOURITES_SUCCESS:            
            return action.response

        case UPDATE_FAVOURITES_SUCCESS: 
            return action.response

        default: 
            return state
    }  
}


const reducer = combineReducers({
    favourites
})


export const fetchFavourites = () => (dispatch) => {
    
    dispatch({type: FETCH_FAVOURITES_REQUEST})

    const userID = isClient() ? localStorage.getItem('userId') : null;

    return fetchData(`wpapi/favourites/${userID}`)
        .then(response => {
            if (typeof response.images !== "undefined") {
                dispatch({
                    type: FETCH_FAVOURITES_SUCCESS,
                    response: Object.assign(defaultFavourites, response)
                })
            } 
        })
        .catch(error => {
            dispatch({
                type: FETCH_FAVOURITES_FAILURE,
                error
            })
        }); 
}

export const updateFavourites = (favourites) => dispatch => {
    
    dispatch({
        type: UPDATE_FAVOURITES_REQUEST
    })

    const userID = isClient() ? localStorage.getItem('userId') : null;

    return postData('wpapi/favourites', {id: userID, data: favourites})
        .then(response => {
            dispatch({
                type: UPDATE_FAVOURITES_SUCCESS,
                response: favourites
            })
        })
        .catch(error => {
            dispatch({
                type: UPDATE_FAVOURITES_FAILURE,
                error
            })
        }); 
}

export const getFavourites = state => state.favourites.favourites

export default reducer



// WEBPACK FOOTER //
// ./client/modules/Favourites/redux.js